import {
  globalSearchParamsSchema,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_JOB_ID = 'jobId'
export const SEARCH_PARAM_MODE = 'mode'

export const jobSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_MODE]: z.enum(['edit', 'create', 'view']).optional(),
  [SEARCH_PARAM_JOB_ID]: z.string().optional(),
})

export type JobSearchParams = z.infer<typeof jobSearchParams>
